import React from 'react';
import './CrossCountryStrip.scss';

function CrossCountryStrip(props) {
    const { country, domain } = props.countryData;
    return (<div className="cross-country-strip padding-12 text-center">
        <span>You are on our Indian Website. To Purchase from {country} Website</span>
        <a href={`https://${domain}?ref=https://www.lenskart.com`} className="button-cta fw500 margin-l20 padding-t4 padding-b4 padding-l12 padding-r12">CLICK HERE</a>
    </div>);
}

export default CrossCountryStrip;
